import React from 'react';

export type DateRangePreset = 'today' | '7days' | '30days' | 'all';

interface DateRangePickerProps {
    selectedPreset: DateRangePreset;
    onPresetChange: (preset: DateRangePreset) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({ selectedPreset, onPresetChange }) => {
    const presets: { value: DateRangePreset; label: string }[] = [
        { value: 'today', label: 'Hoje' },
        { value: '7days', label: 'Últimos 7 dias' },
        { value: '30days', label: 'Últimos 30 dias' },
        { value: 'all', label: 'Tudo' },
    ];

    return (
        <div className="flex items-center gap-2 bg-white dark:bg-gray-800 rounded-lg p-1 border border-gray-200 dark:border-gray-700">
            {presets.map((preset) => (
                <button
                    key={preset.value}
                    onClick={() => onPresetChange(preset.value)}
                    className={`
                        px-4 py-2 rounded-md text-sm font-medium transition-all
                        ${selectedPreset === preset.value
                            ? 'bg-primary text-white shadow-md'
                            : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
                        }
                    `}
                >
                    {preset.label}
                </button>
            ))}
        </div>
    );
};

export default DateRangePicker;
